import { FilterFn } from '@tanstack/react-table';

import { NumberFilterValue } from '../components/Filters/NumberFilter';

const minMaxFilter: FilterFn<unknown> = (row, columnId, value) => {
  const { min, max } = (value || {}) as NumberFilterValue;
  const columnValue = row.getValue(columnId) as number;

  if (min !== null && max !== null) {
    return columnValue >= min && columnValue <= max;
  } else if (max !== null) {
    return columnValue <= max;
  } else if (min !== null) {
    return columnValue >= min;
  }
  return true;
};

export { minMaxFilter };
